module.exports = __webpack_public_path__ + "static/11-mission2-Text-5132aa31ec080579edb9bc1d11828a46.png";